import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DefaultAIMarkersDialogComponent } from './default-ai-markers-dialog.component';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TrackByPropPipeModule } from '@go-modules/pipes/track-by-prop/track-by-prop-pipe.module';
import { CommonModule } from '@angular/common';
import { GoSelectModule } from '@go-modules/directives/go-select/go-select.module';
import { MarkerModule } from '@go-modules/components/marker/marker.module';
import { A11yModule } from '@angular/cdk/a11y';
import { DisabledInteractiveDirective } from '@go-modules/directives/disabled-interactive/disabled-interactive.directive';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		FormsModule,
		ReactiveFormsModule,
		TrackByPropPipeModule,
		GoSelectModule,
		MarkerModule,
		A11yModule,
		DisabledInteractiveDirective
	],
	declarations: [
		DefaultAIMarkersDialogComponent
	],
	exports: [
		DefaultAIMarkersDialogComponent
	]
})
export class DefaultAIMarkersDialogModule {}
